/**
 * @documental
 * @export LinkItem
 * @name
 * Menu.LinkItem
 */

import { FC } from "react";
import { LinkProps } from "react-router";
import { ItemProps } from "./Item";

/**
 * The `Item` component properties.
 */
export interface LinkItemProps extends Omit<ItemProps, "onClick"> {
  /**
   * The address to link to.
   */
  readonly to: LinkProps["to"];

  /**
   * The link target.
   */
  readonly target?: LinkProps["target"];
}

/**
 * A single item for the `Menu` component.
 */
export const LinkItem: FC<LinkItemProps> = () => {
  return null;
};
